import { useEffect, useMemo } from "react";
import { Outlet, useLocation, useNavigate, NavLink } from "react-router-dom";
import { Tabs } from "@/components";
import { useParams } from "react-router";
const CustomerDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();
  useEffect(() => {
    navigate(`/customer/details/${id}/kycDetails`, { replace: true }); // Prevents unnecessary history entries
  }, []);
  const tabs = useMemo(
    () => [
      { label: "KYC Details", link: "kycDetails" },
      { label: "Login Credentials", link: "loginCredentials" },
      { label: "Applied Rates", link: "appliedRate" },
      { label: "Pickup Address", link: "pickupAddress" },
      { label: "Shipping ID", link: "shippingId" },
      { label: "COD Remittance", link: "codRemittance" },
    ],
    []
  );
  return (
    <div className="flex flex-col w-full max-w-[2000px]  lg:pb-0  relative">
      <Tabs tabs={tabs} NavLink={NavLink} />
      <Outlet />
    </div>
  );
};

export default CustomerDetails;
